import templateUrl from './help.html';

function frmHelp() {
  return {
    templateUrl: templateUrl,
    transclude: true
  };
}

export default frmHelp;



/** WEBPACK FOOTER **
 ** ./src/app/forms/help.directive.js
 **/